export default <const>[
  {
    id: 'ball_morning_001',
    pet_id: 'ball',
    time: 'morning',
    text_1_jp:
      '{player_name}、おはよーコロ\n\n朝だコロよ〜\n\n今日もいっぱいあそぶコロ！',
    text_1_en:
      "Good morning, {player_name}\n\nIt's a very good morning!\n\nLet's play a lot!",
  },
  {
    id: 'ball_lunch_001',
    pet_id: 'ball',
    time: 'lunch',
    text_1_jp:
      'お昼ごはん、もう食べたコロ？\n\nまだこれからコロ？\n\nごはん食べたらあそびに来て欲しいコロ！',
    text_1_en:
      "Did you eat lunch yet?\n\nNot yet?\n\nPlease come visit me after you've eaten!",
  },
  {
    id: 'ball_evening_001',
    pet_id: 'ball',
    time: 'evening',
    text_1_jp:
      '今日もいっぱいあそんでくれて、どうもありがとうコロ\n\n{pet_name}は、{player_name}にあそんでもらうのが一番楽しいコロ！\n\nまた明日もいっしょにあそんでコロね！',
    text_1_en:
      "Thank you very much for playing with me today.\n\nI really love playing with you!\n\nI'll see you tomorrow to play with you!",
  },
  {
    id: 'starball_morning_001',
    pet_id: 'starball',
    time: 'morning',
    text_1_jp:
      '{player_name}、おはよースタ！\n\nもう朝だスタ！\n\n早く起きていっしょにあそんで欲しいスタ！',
    text_1_en:
      "Good morning, {player_name}!\n\nIt's already morning!\n\nWake up and come to play with me!",
  },
  {
    id: 'starball_lunch_001',
    pet_id: 'starball',
    time: 'lunch',
    text_1_jp:
      'お昼だスター\n\n{pet_name}も、そろそろご飯食べたいスタ！\n\n{player_name}のお昼が済んだら、あそびに来て欲しいスタ！',
    text_1_en:
      "It's lunch time!\n\nI want to eat something too!\n\nPlease come visit me after you've eaten!",
  },
  {
    id: 'starball_evening_001',
    pet_id: 'starball',
    time: 'evening',
    text_1_jp:
      '今日も楽しかったスター\n\n明日もきっと楽しい日スタ！\n\n寝る前に、ちょっとあそびに来るスタ？',
    text_1_en:
      'It was a great day again!\n\nTomorrow is going to be a great day too!\n\nDo you want to come and play with me before going to bed?',
  },
  {
    id: 'crab_morning_001',
    pet_id: 'crab',
    time: 'morning',
    text_1_jp:
      '{player_name}、おはカニ〜！よく眠れたカニか？\n\n睡眠はとっても重要カニ！\n\nもし眠り足りなかったら、あと5分だけ寝てもいいカニよ',
    text_1_en:
      "Good morning, {player_name}! Did you sleep well?\n\nSleep is so important!\n\nIf you didn't get enough sleep, you can sleep for five more minutes.",
  },
  {
    id: 'crab_lunch_001',
    pet_id: 'crab',
    time: 'lunch',
    text_1_jp:
      'お昼ごはんは食べすぎると午後眠くなっちゃうカニ！\n\n腹八分目が体にもいいカニ！\n\n眠たかったら15分ぐらい仮眠するとスッキリするカニよ！',
    text_1_en:
      "Eating too much for lunch makes you sleepy in the afternoon!\n\nIt's good for you to keep your lunch portions low!\n\nIf you need to sleep, take a 15-minute nap and you'll feel better!",
  },
  {
    id: 'crab_evening_001',
    pet_id: 'crab',
    time: 'evening',
    text_1_jp:
      '今日もいっぱい一緒にあそんでくれて、どうもありがとうカニ！\n\n夜はスマホの画面を見すぎると睡眠の質が悪くなっちゃうから気をつけるカニ！\n\nでも、ちょっとぐらいならあそびに来てくれてもいいカニよ…？',
    text_1_en:
      'Thank you so much for playing with me today!\n\nBe careful at night, too much staring at your phone screen will hurt your sleep quality!\n\nBut you can come and play with me for a little while...',
  },
  {
    id: 'hamster_morning_001',
    pet_id: 'hamster',
    time: 'morning',
    text_1_jp:
      'おはハムー\n\nまだちょっと眠いハムー\n\nでも、早くあそんで欲しいからがんばって起きたハム！',
    text_1_en:
      "Good morning!\n\nI'm a little sleepy yet.\n\nI did my best to get up to play early.",
  },
  {
    id: 'hamster_lunch_001',
    pet_id: 'hamster',
    time: 'lunch',
    text_1_jp:
      'お昼ごはんの時間ハムー\n\n早くお昼食べちゃうハムー\n\n{pet_name}といっしょにあそぶハムー',
    text_1_en:
      "It's time for lunch!\n\nLet's eat lunch quickly\n\nand play with me!",
  },
  {
    id: 'hamster_evening_001',
    pet_id: 'hamster',
    time: 'evening',
    text_1_jp:
      '今日もいっっぱいあそんだハムねー\n\nどうもありがとハム！\n\n寝る前に、もうちょっとだけ遊ばないハムか？だめハム？',
    text_1_en:
      "We played a lot today!\n\nThank you so much!\n\nWhy don't we play one more time before sleeping? Whad do you think?",
  },
  {
    id: 'turtle_morning_001',
    pet_id: 'turtle',
    time: 'morning',
    text_1_jp:
      'おはようカメー\n\n早起きは三文の徳カメー\n\n早く起きてあそびに来て欲しいカメー',
    text_1_en:
      'Good morning.\n\nThey say the early bird gets the worm.\n\nPelase get up early and come play with me.',
  },
  {
    id: 'turtle_lunch_001',
    pet_id: 'turtle',
    time: 'lunch',
    text_1_jp:
      'お昼ごはんは早食いせずに、よく噛んで食べるカメー\n\nよくカメ、だカメー\n\nいらんこと言ったカメー',
    text_1_en:
      "Don't eat lunch too fast, chew your food well.\n\nChew well.\n\nI said something I didn't mean.",
  },
  {
    id: 'turtle_evening_001',
    pet_id: 'turtle',
    time: 'evening',
    text_1_jp:
      '今日も一日、お世話になったカメー\n\n{player_name}氏にあそんでいただくのは、本当に楽しいカメー\n\n一日の終わりにもう少しあそんで欲しいカメー',
    text_1_en:
      "Thank you for taking care of me today again.\n\nIt's really fun to play with you, {player_name}!\n\nIt'd be great if we could play a little more before the end of the day.",
  },
  {
    id: 'dog_morning_001',
    pet_id: 'dog',
    time: 'morning',
    text_1_jp:
      '{player_name}、おはよーヌ\n\n今日のお天気はいかがかヌ？\n\nおでかけするなら、天気予報を忘れずにチェックするヌ！',
    text_1_en:
      "Good morning, {player_name}\n\nHow is the weather today?\n\nIf you're going out, don't forget to check the weather forecast!",
  },
  {
    id: 'dog_lunch_001',
    pet_id: 'dog',
    time: 'lunch',
    text_1_jp:
      '{player_name}、お昼だヌー\n\nもうお昼ごはん食べたヌ？\n\nごはん食べたらいっしょにあそぶヌ！',
    text_1_en:
      "It's lunch time, {player_name}\n\nDid you eat lunch yet?\n\nLet's play together after eating lunch!",
  },
  {
    id: 'dog_evening_001',
    pet_id: 'dog',
    time: 'evening',
    text_1_jp:
      '今日もいっぱいあそんだヌね〜。たのしかったヌ\n\n明日のお天気はどうかヌね？\n\n晴れても雨でも、またいっしょにあそぶヌ！',
    text_1_en:
      "We had a lot of fun today, didn't we?\n\nWhat do you think the weather will be like tomorrow?\n\nSunny or rainy, we'll play together again!",
  },
  {
    id: 'seaotter_morning_001',
    pet_id: 'seaotter',
    time: 'morning',
    text_1_jp:
      'おはよッコ！\n\n今日も良い日になりそうッコ！\n\nラッコッコッコッコ！',
    text_1_en:
      "Good morning!\n\nI guess it's going to be a great day!\n\nWoo-hoo!",
  },
  {
    id: 'seaotter_lunch_001',
    pet_id: 'seaotter',
    time: 'lunch',
    text_1_jp:
      'お昼ごはんは何貝にするッコ？\n\nえ？貝じゃないッコ？\n\n貝を食べずに何を食べるッコ…？',
    text_1_en:
      "What shellfish are you going to eat for lunch?\n\nWhat? Not shellfish?\n\nWhat on earth would you eat if you didn't eat shellfish?",
  },
  {
    id: 'seaotter_evening_001',
    pet_id: 'seaotter',
    time: 'evening',
    text_1_jp:
      'あー。今日も良い日だったッコ！\n\n{player_name}、ありがとッコ！\n\n明日もたくさんあそんでッコ！',
    text_1_en:
      'It was a great day again!\n\nThank you so much, {player_name}!\n\nPlease play with me a lot tomorrow again!',
  },
  {
    id: 'cat_morning_001',
    pet_id: 'cat',
    time: 'morning',
    text_1_jp:
      'おはよーミャー\n\nもう起きてるミャー？\n\n{pet_name}はもうちょっと寝るミャー。でも、どうしてもって言うならあそんでやるミャー',
    text_1_en:
      "Good morning...\n\nAre you awake already...?\n\nI'll sleep a little bit more, but I can play with you if you really want to.",
  },
  {
    id: 'cat_lunch_001',
    pet_id: 'cat',
    time: 'lunch',
    text_1_jp:
      'お昼ごはんくださいミャー\n\n{player_name}のご飯がおわってからでいいミャー\n\nいや、やっぱり先にくださいミャー',
    text_1_en:
      'Please give me some food for lunch.\n\nAfter your lunch is fine.\n\nNo, before your lunch, pelase.',
  },
  {
    id: 'cat_evening_001',
    pet_id: 'cat',
    time: 'evening',
    text_1_jp:
      'スースー\n\nスースー\n\nハッ！ちょっと寝てただけだミャ！もう眠いから早くあそびに来るミャ！',
    text_1_en:
      "Zzzz\n\nZzzz\n\nI was just having a short nap! I'm sleepy, so come play with me soon!",
  },
  {
    id: 'whale_morning_001',
    pet_id: 'whale',
    time: 'morning',
    text_1_jp:
      '{player_name}、おはよーラー\n\n今日もすごく良い日になりそうな気がするラー\n\n{pet_name}の勘は、たいてい当たったり外れたりするラー',
    text_1_en:
      "Good morning, {player_name}!\n\nI think it's going to be a great day again!\n\nMy intuition is usually right or wrong.",
  },
  {
    id: 'whale_lunch_001',
    pet_id: 'whale',
    time: 'lunch',
    text_1_jp:
      'お昼の時間ラー\n\n今日のメニューはなにかラー？\n\nお昼終わったらあそびに来て欲しいラー',
    text_1_en:
      "It's lunch time!\n\nWhat would be today's menu?\n\nPelase come and play with me after lunch!",
  },
  {
    id: 'whale_evening_001',
    pet_id: 'whale',
    time: 'evening',
    text_1_jp:
      'もうすっかり夜ラー\n\nでも、もうちょっとだけあそびたい気もするラー\n\n寝る前にちょっとだけ来て欲しいラー',
    text_1_en:
      "It's already nighttime.\n\nBut I feel like I want to play with you just a little bit more.\n\nI want you to come over for a little while before you go to bed.",
  },
  {
    id: 'giraffe_morning_001',
    pet_id: 'giraffe',
    time: 'morning',
    text_1_jp:
      '{player_name}、おはようリン！\n\nおでかけのときには戸締まりを忘れずにリン！\n\n準備できたらあそびに来てリン！',
    text_1_en:
      "Good morning, {player_name}!\n\nDon't forget to lock up when you go out!\n\nCome play when you're ready!",
  },
  {
    id: 'giraffe_lunch_001',
    pet_id: 'giraffe',
    time: 'lunch',
    text_1_jp:
      'お昼だリン！\n\n{pet_name}といっしょにあそぶリン！\n\nキャッキャッキャ！',
    text_1_en:
      "It's lunch time!\n\nLet's play with me!\n\nCackel, cackle, cackle!",
  },
  {
    id: 'giraffe_evening_001',
    pet_id: 'giraffe',
    time: 'evening',
    text_1_jp:
      '今日もいーーっぱいあそんだリンねー！\n\n明日ももーーっといっぱあそんで欲しいリン！\n\nなんなら今からもう1回あそぶリン！',
    text_1_en:
      'We had lots of fun today!\n\nI want to have lots more fun tomorrow!\n\nIf you want, we can play one more time now!',
  },
];
